import { Link } from "react-router-dom";
import { Instagram, MapPin, Clock, Mail, Phone } from "lucide-react";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Footer() {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  const hasContact =
    settings && (settings.store_address || settings.store_hours || settings.instagram || settings.email || settings.phone);

  const instaUrl = settings?.instagram
    ? settings.instagram.startsWith("http")
      ? settings.instagram
      : `https://instagram.com/${settings.instagram.replace(/^@/, "")}`
    : null;

  return (
    <footer data-testid="site-footer" className="border-t border-[#E5E0D8] bg-cream mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-16 md:py-24 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-4">
            <img
              src="https://customer-assets.emergentagent.com/job_dress-rental-8/artifacts/addnkbh0_01282ab7-d3ab-4bd8-a457-edb52e8d5072.jpeg"
              alt="10/10 Kleiderverleih"
              className="h-20 w-auto object-contain rounded"
            />
          </div>
          <div className="mt-5">
            <a
              href="https://10von10kleiderverleih.de"
              target="_blank"
              rel="noreferrer"
              className="text-sm tracking-[0.25em] uppercase text-gold link-underline"
              data-testid="footer-domain"
            >
              10von10kleiderverleih.de
            </a>
          </div>
          <p className="mt-6 max-w-md text-ink/70 leading-relaxed">
            Mieten statt kaufen. Glänzen ohne Stress. Premium Designer-Kleider für unvergessliche Momente –
            ausgewählt, gepflegt und persönlich angepasst in unserem Laden.
          </p>
        </div>

        {hasContact && (
          <div>
            <div className="overline mb-4">Boutique</div>
            <ul className="space-y-3 text-sm">
              {settings.store_address && (
                <li className="flex items-start gap-2 text-ink/80"><MapPin size={14} className="mt-1 text-gold shrink-0" />{settings.store_address}</li>
              )}
              {settings.store_hours && (
                <li className="flex items-start gap-2 text-ink/80"><Clock size={14} className="mt-1 text-gold shrink-0" />{settings.store_hours}</li>
              )}
              {settings.phone && (
                <li className="flex items-start gap-2 text-ink/80"><Phone size={14} className="mt-1 text-gold shrink-0" />{settings.phone}</li>
              )}
              {settings.email && (
                <li className="flex items-start gap-2 text-ink/80"><Mail size={14} className="mt-1 text-gold shrink-0" />{settings.email}</li>
              )}
              {instaUrl && (
                <li className="flex items-start gap-2 text-ink/80">
                  <Instagram size={14} className="mt-1 text-gold shrink-0" />
                  <a href={instaUrl} target="_blank" rel="noreferrer" className="link-underline">{settings.instagram}</a>
                </li>
              )}
            </ul>
          </div>
        )}

        <div>
          <div className="overline mb-4">Navigation</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/" className="link-underline text-ink/80">Home</Link></li>
            <li><Link to="/kleider" className="link-underline text-ink/80">Alle Kleider</Link></li>
            <li><Link to="/#anfrage" className="link-underline text-ink/80">Anfrage senden</Link></li>
            <li><Link to="/impressum" className="link-underline text-ink/80">Impressum</Link></li>
            <li><Link to="/datenschutz" className="link-underline text-ink/80">Datenschutz</Link></li>
            <li><Link to="/admin/login" data-testid="footer-admin-link" className="link-underline text-ink/60">Admin</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#E5E0D8]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-6 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-ink/50">
          <span>© {new Date().getFullYear()} 10/10 Kleiderverleih. Alle Rechte vorbehalten.</span>
          <span>Mieten · Anprobieren · Strahlen</span>
        </div>
      </div>
    </footer>
  );
}
